/* Pete's Recipes — shared shopping-list drawer for recipe and listing pages. */
(function () {
  var KEY = 'petes_shopping_list';
  var fab = null, badge = null, backdrop = null, drawer = null, bodyEl = null, returnFocus = null;

  function storageSet(key, value) {
    try { localStorage.setItem(key, value); return true; } catch (e) { return false; }
  }

  function toast(msg) {
    var t = document.querySelector('.recipe-toast') || (function () {
      var el = document.createElement('div'); el.className = 'recipe-toast'; document.body.appendChild(el); return el;
    })();
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.classList.remove('is-visible'); }, 2200);
  }

  function uid() {
    return String(new Date().getTime()) + '-' + String(Math.random()).slice(2);
  }

  function getList() {
    var raw;
    try { raw = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { raw = []; }
    if (!raw || !raw.length) return [];
    return raw.map(function (item, index) {
      if (typeof item === 'string') return { id: 'legacy-' + index + '-' + item.toLowerCase().trim(), qty: '', name: item, recipe: 'Other', done: false };
      item = item || {};
      return {
        id: item.id || uid(),
        qty: item.qty || '',
        name: item.name || '',
        recipe: item.recipe || 'Other',
        done: !!item.done
      };
    }).filter(function (item) { return item.name; });
  }

  function saveList(list) {
    storageSet(KEY, JSON.stringify(list));
    refresh();
  }

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (ch) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[ch];
    });
  }

  function productHandle(name) {
    var m = String(name || '').match(/^pete'?s\s+(.+)$/i);
    var shape;
    if (!m) return '';
    shape = m[1].toLowerCase().replace(/\s+/g, ' ').trim();
    // ingredient lines often offer alternatives ("Spaghetti or Fettuccine") — map the first shape
    shape = shape.split(' or ')[0].split(',')[0].trim();
    if (shape === 'spaghetti') return 'spaghetti';
    if (shape === 'linguine') return 'linguine';
    if (shape === 'fettuccine') return 'fettuccine';
    if (shape === 'penne') return 'penne';
    if (shape === 'rotini') return 'rotini';
    if (shape === 'elbows') return 'elbows';
    if (shape === 'lasagna') return 'lasagna';
    if (shape === 'gnocchi keto') return 'gnocchi-keto';
    if (shape === 'gnocchi lite') return 'gnocchi-lite';
    if (shape === 'gnocchi pro') return 'gnocchi-pro';
    if (shape === 'gnocchi') return 'gnocchi';
    return '';
  }

  function countsByName(list) {
    var counts = {};
    list.forEach(function (item) {
      var key = item.name.toLowerCase().trim();
      counts[key] = (counts[key] || 0) + 1;
    });
    return counts;
  }

  function grouped(list) {
    var order = [], groups = {};
    list.forEach(function (item) {
      var recipe = item.recipe || 'Other';
      if (!groups[recipe]) { groups[recipe] = []; order.push(recipe); }
      groups[recipe].push(item);
    });
    return { order: order, groups: groups };
  }

  function render() {
    var list = getList();
    var data = grouped(list);
    var dupes = countsByName(list);
    var html = '';
    if (!bodyEl) return;
    if (!list.length) {
      html = '<p class="recipes-sl-drawer__empty">Your shopping list is empty.</p>';
    } else {
      data.order.forEach(function (recipe) {
        html += '<section class="recipes-sl-group"><h3 class="recipes-sl-group__title">' + escapeHtml(recipe) + '</h3>';
        data.groups[recipe].forEach(function (item) {
          var handle = productHandle(item.name);
          var key = item.name.toLowerCase().trim();
          var nameHtml = handle ? '<a href="/products/' + handle + '">' + escapeHtml(item.name) + '</a>' : escapeHtml(item.name);
          html += '<div class="recipes-sl-item' + (item.done ? ' is-done' : '') + '" data-sl-id="' + escapeHtml(item.id) + '">' +
            '<label class="recipes-sl-item__check"><input type="checkbox" data-sl-done' + (item.done ? ' checked' : '') + '><span class="recipes-sl-item__text">' +
            (item.qty ? '<strong>' + escapeHtml(item.qty) + '</strong> ' : '') + '<span>' + nameHtml + '</span>' +
            (dupes[key] > 1 ? ' <span class="recipes-sl-item__pill">×' + dupes[key] + '</span>' : '') +
            '</span></label>' +
            (handle ? '<button class="recipes-sl-item__cart" type="button" data-sl-cart="' + handle + '">Add to cart</button>' : '') +
            '<button class="recipes-sl-item__remove" type="button" data-sl-remove aria-label="Remove ' + escapeHtml(item.name) + '">×</button>' +
            '</div>';
        });
        html += '</section>';
      });
    }
    bodyEl.innerHTML = html;
  }

  function refresh() {
    var list = getList();
    if (fab) {
      fab.hidden = !list.length;
      badge.textContent = list.length;
    }
    render();
  }

  function openDrawer() {
    returnFocus = document.activeElement;
    render();
    backdrop.hidden = false;
    drawer.hidden = false;
    setTimeout(function () {
      backdrop.classList.add('is-open');
      drawer.classList.add('is-open');
      drawer.querySelector('.recipes-sl-drawer__close').focus();
    }, 0);
  }

  function closeDrawer() {
    backdrop.classList.remove('is-open');
    drawer.classList.remove('is-open');
    setTimeout(function () {
      backdrop.hidden = true;
      drawer.hidden = true;
    }, 250);
    if (returnFocus && returnFocus.focus) { returnFocus.focus(); returnFocus = null; }
  }

  function listAsText() {
    var list = getList(), data = grouped(list), lines = [];
    data.order.forEach(function (recipe) {
      lines.push(recipe);
      data.groups[recipe].forEach(function (item) { lines.push('[ ] ' + (item.qty ? item.qty + ' ' : '') + item.name); });
      lines.push('');
    });
    return lines.join('\n').trim();
  }

  function copyList() {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(listAsText()).then(function () { toast('List copied!'); }).catch(function () {});
    }
  }

  function downloadList() {
    var blob = new Blob([listAsText() + '\n'], { type: 'text/plain;charset=utf-8' });
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = 'petes-shopping-list.txt';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
    toast('List downloaded');
  }

  function printList() {
    var list = getList();
    if (!list.length) return;
    var data = grouped(list);
    var box = document.querySelector('.recipes-sl-print') || (function () {
      var el = document.createElement('div'); el.className = 'recipes-sl-print'; document.body.appendChild(el); return el;
    })();
    var html = '<h1>Pete’s Pasta — Shopping list</h1>';
    data.order.forEach(function (recipe) {
      html += '<h2>' + escapeHtml(recipe) + '</h2><ul>';
      data.groups[recipe].forEach(function (item) {
        html += '<li>☐ ' + (item.qty ? '<strong>' + escapeHtml(item.qty) + '</strong> ' : '') + escapeHtml(item.name) + '</li>';
      });
      html += '</ul>';
    });
    box.innerHTML = html;
    document.body.classList.add('recipes-sl-printing');
    var cleanup = function () { document.body.classList.remove('recipes-sl-printing'); window.removeEventListener('afterprint', cleanup); };
    window.addEventListener('afterprint', cleanup);
    window.print();
    setTimeout(cleanup, 2000); // safety for browsers that skip afterprint
  }

  function addToCart(handle) {
    fetch('/products/' + handle + '.js')
      .then(function (res) { return res.json(); })
      .then(function (product) {
        var variants = product.variants || [];
        var variant = variants.filter(function (v) { return v.available; })[0] || variants[0];
        if (!variant) throw new Error('No variant');
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart add failed');
        if (window.updateCart) window.updateCart();
        toast('Added to cart');
      })
      .catch(function () {});
  }

  function bindEvents() {
    fab.addEventListener('click', openDrawer);
    backdrop.addEventListener('click', closeDrawer);
    drawer.querySelector('.recipes-sl-drawer__close').addEventListener('click', closeDrawer);
    drawer.querySelector('[data-sl-copy]').addEventListener('click', copyList);
    drawer.querySelector('[data-sl-download]').addEventListener('click', downloadList);
    drawer.querySelector('[data-sl-print]').addEventListener('click', printList);
    drawer.querySelector('[data-sl-clear-checked]').addEventListener('click', function () {
      saveList(getList().filter(function (item) { return !item.done; }));
    });
    drawer.querySelector('[data-sl-clear-all]').addEventListener('click', function () {
      if (window.confirm('Clear the whole shopping list?')) saveList([]);
    });
    bodyEl.addEventListener('click', function (e) {
      var remove = e.target.closest('[data-sl-remove]');
      var cart = e.target.closest('[data-sl-cart]');
      var id, itemEl;
      if (remove) {
        itemEl = remove.closest('[data-sl-id]');
        id = itemEl && itemEl.getAttribute('data-sl-id');
        saveList(getList().filter(function (item) { return item.id !== id; }));
      }
      if (cart) addToCart(cart.getAttribute('data-sl-cart'));
    });
    bodyEl.addEventListener('change', function (e) {
      var done = e.target.closest('[data-sl-done]');
      var itemEl, id, list;
      if (!done) return;
      itemEl = done.closest('[data-sl-id]');
      id = itemEl && itemEl.getAttribute('data-sl-id');
      list = getList();
      list.forEach(function (item) { if (item.id === id) item.done = done.checked; });
      saveList(list);
    });
    document.addEventListener('keydown', function (e) {
      if (!drawer || drawer.hidden || e.key !== 'Escape') return;
      closeDrawer();
    });
    window.addEventListener('storage', function (e) { if (e.key === KEY) refresh(); });
  }

  function init() {
    fab = document.createElement('button');
    fab.className = 'recipes-sl-fab';
    fab.type = 'button';
    fab.innerHTML = '<svg class="recipes-sl-fab__ico" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M13.125 12V15.75C13.125 16.0484 13.0065 16.3345 12.7955 16.5455C12.5845 16.7565 12.2984 16.875 12 16.875C11.7016 16.875 11.4155 16.7565 11.2045 16.5455C10.9935 16.3345 10.875 16.0484 10.875 15.75V12C10.875 11.7016 10.9935 11.4155 11.2045 11.2045C11.4155 10.9935 11.7016 10.875 12 10.875C12.2984 10.875 12.5845 10.9935 12.7955 11.2045C13.0065 11.4155 13.125 11.7016 13.125 12ZM15.7556 11.8884L15.3806 15.6384C15.3511 15.9353 15.4406 16.2318 15.6296 16.4626C15.8186 16.6934 16.0916 16.8398 16.3884 16.8694C16.4259 16.8694 16.4644 16.875 16.5009 16.875C16.7798 16.8747 17.0487 16.7709 17.2553 16.5837C17.462 16.3964 17.5917 16.1391 17.6194 15.8616L17.9944 12.1116C18.0202 11.8166 17.9288 11.5234 17.7399 11.2955C17.551 11.0675 17.2798 10.9232 16.9852 10.8938C16.6906 10.8645 16.3964 10.9524 16.1662 11.1386C15.936 11.3248 15.7885 11.5942 15.7556 11.8884ZM8.24437 11.8884C8.21152 11.5942 8.06401 11.3248 7.83382 11.1386C7.60364 10.9524 7.30935 10.8645 7.01475 10.8938C6.72016 10.9232 6.44901 11.0675 6.26011 11.2955C6.0712 11.5234 5.97976 11.8166 6.00562 12.1116L6.38062 15.8616C6.4083 16.1392 6.53817 16.3967 6.74503 16.584C6.95188 16.7713 7.22096 16.875 7.5 16.875C7.53656 16.875 7.575 16.875 7.6125 16.8694C7.90937 16.8398 8.18232 16.6934 8.37132 16.4626C8.56031 16.2318 8.64988 15.9353 8.62031 15.6384L8.24437 11.8884ZM22.8694 8.39906L21.4566 18.9928C21.3964 19.4443 21.1744 19.8587 20.8318 20.1589C20.4892 20.459 20.0493 20.6247 19.5937 20.625H4.40625C3.95225 20.6237 3.51405 20.4582 3.17253 20.1591C2.83101 19.8599 2.60923 19.4474 2.54812 18.9975L1.13531 8.40375C1.11334 8.24451 1.12575 8.08241 1.17171 7.92838C1.21766 7.77434 1.2961 7.63194 1.40172 7.51077C1.50735 7.3896 1.63771 7.29247 1.78404 7.22592C1.93037 7.15938 2.08925 7.12496 2.25 7.125H6.23906L11.1562 1.50937C11.2618 1.38873 11.392 1.29204 11.538 1.2258C11.684 1.15956 11.8425 1.12529 12.0028 1.12529C12.1631 1.12529 12.3216 1.15956 12.4676 1.2258C12.6136 1.29204 12.7438 1.38873 12.8494 1.50937L17.7609 7.125H21.75C21.9103 7.12505 22.0687 7.15936 22.2147 7.22563C22.3606 7.2919 22.4907 7.38859 22.5963 7.50922C22.7018 7.62986 22.7804 7.77167 22.8267 7.92513C22.873 8.0786 22.8859 8.24018 22.8647 8.39906H22.8694ZM9.22969 7.125H14.7703L12 3.95812L9.22969 7.125ZM20.4647 9.375H3.53531L4.73531 18.375H19.2666L20.4647 9.375Z" fill="currentColor"/></svg><span class="recipes-sl-fab__badge">0</span>';
    fab.setAttribute('aria-label', 'Open shopping list');
    document.body.appendChild(fab);
    badge = fab.querySelector('.recipes-sl-fab__badge');

    backdrop = document.createElement('div');
    backdrop.className = 'recipes-sl-backdrop';
    backdrop.hidden = true;
    document.body.appendChild(backdrop);

    drawer = document.createElement('aside');
    drawer.className = 'recipes-sl-drawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-label', 'Shopping list');
    drawer.hidden = true;
    drawer.innerHTML = '<div class="recipes-sl-drawer__head"><h2>Shopping list</h2><button class="recipes-sl-drawer__close" type="button" aria-label="Close">×</button></div>' +
      '<div class="recipes-sl-drawer__body"></div>' +
      '<div class="recipes-sl-drawer__footer"><button type="button" data-sl-copy>Copy list</button><button type="button" data-sl-download>Download</button><button type="button" data-sl-print>Print / PDF</button><button type="button" data-sl-clear-checked>Clear checked</button><button type="button" data-sl-clear-all>Clear all</button></div>';
    document.body.appendChild(drawer);
    bodyEl = drawer.querySelector('.recipes-sl-drawer__body');

    bindEvents();
    refresh();
    window.petesShoppingListRefresh = refresh;
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
